import NotFoundPage from 'pages/404';
import Card from 'pages/card';
import CardHolderInfo from 'pages/card-holder';
import CardHolders from 'pages/card-holders';
import CardHoldersNew from 'pages/card-holders-new';
import CardProduct from 'pages/issuer/card-product';
import CardProducts from 'pages/issuer/card-products';
import CurrencyExchange from 'pages/issuer/currency-exchange';
import Exporter from 'pages/issuer/exporter';
import GroupPage from 'pages/issuer/group';
import NewCard from 'pages/issuer/new-card';
import Settlement from 'pages/issuer/settlement';
import UserPage from 'pages/issuer/user';
import Login from 'pages/login';
import LogoutPage from 'pages/logout';
import Settings from 'pages/settings';
import Transaction from 'pages/transaction';
import Transactions from 'pages/transactions';
import WelcomePage from 'pages/welcome';
import React from 'react';
import { RouteProps } from 'react-router-dom';
import CardStateNew from 'pages/issuer/new-card-state';
import UnnamedLots from '../pages/unnameds';
import UnnamedLot from '../pages/unnamed'
import PrivateRoute from './helpers';
import BulkLoad from 'pages/issuer/bulk-load';
import NewCardProduct from '../pages/issuer/new-card-product';
import CardAffinityGroups from '../components/CardAffinityGroups/card-affinity-groups';
import CardAffinityGroup from '../components/CardAffinityGroups/card-affinity-group';
import NewCardAffinityGroup from '../components/CardAffinityGroups/new-card-affinity-group';
import UsageLimitsPage from '../components/UsageLimits/usage-limits-page';
import UsageLimitPage from '../components/UsageLimits/usage-limit-page';
import Claims from 'pages/claims/claims';
import ClaimDetail from 'pages/claims/claim-detail';
import ClaimNew from '../pages/claims/claim-new';
import Dashboard from '../pages/Dashboard/dashboard';

const routes: RouteProps[] = [
  {
    path: '/:issuer/login',
    element: <Login />,
  },
  {
    path: '/:issuer/logout',
    element: <LogoutPage />,
  },
  {
    path: '/:issuer/welcome',
    element: (
      <PrivateRoute>
        <WelcomePage />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-holders',
    element: (
      <PrivateRoute>
        <CardHolders />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-holders/new',
    element: (
      <PrivateRoute>
        <CardHoldersNew />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/cards/card-state-new/:id',
    element: (
      <PrivateRoute>
        <CardStateNew />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-holders/:id',
    element: (
      <PrivateRoute>
        <CardHolderInfo />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/cards/:id',
    element: (
      <PrivateRoute>
        <Card />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/transactions/:cardId',
    element: (
      <PrivateRoute>
        <Transactions />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/transactions/:cardId/:trxId',
    element: (
      <PrivateRoute>
        <Transaction />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/settings',
    element: (
      <PrivateRoute>
        <Settings />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/settings/groups/:groupId',
    element: (
      <PrivateRoute>
        <GroupPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/settings/users/:userId',
    element: (
      <PrivateRoute>
        <UserPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/exporter',
    element: (
      <PrivateRoute>
        <Exporter />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/settlement',
    element: (
      <PrivateRoute>
        <Settlement />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-products',
    element: (
      <PrivateRoute>
        <CardProducts />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/bulk-load',
    element: (
      <PrivateRoute>
        <BulkLoad />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-products/:cardProductId',
    element: (
      <PrivateRoute>
        <CardProduct />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/currency-exchange',
    element: (
      <PrivateRoute>
        <CurrencyExchange />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-holders/cards/new',
    element: (
      <PrivateRoute>
        <NewCard />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/unnamed-lots',
    element: (
      <PrivateRoute>
        <UnnamedLots />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/unnamed-lots/:lotNumber',
    element: (
      <PrivateRoute>
        <UnnamedLot />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/new-card-product',
    element: (
      <PrivateRoute>
        <NewCardProduct />
      </PrivateRoute>
    ),
  },
  {
    path: '/:issuer/card-affinity-groups',
    element: (
      <PrivateRoute>
        <CardAffinityGroups />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/card-affinity-groups/:cardAffinityGroupId',
    element: (
      <PrivateRoute>
        <CardAffinityGroup />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/card-affinity-groups/new',
    element: (
      <PrivateRoute>
        <NewCardAffinityGroup />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/usage-limits',
    element: (
      <PrivateRoute>
        <UsageLimitsPage />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/usage-limits/:usageLimitId',
    element: (
      <PrivateRoute>
        <UsageLimitPage />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/claims',
    element: (
      <PrivateRoute>
        <Claims />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/claims/:id',
    element: (
      <PrivateRoute>
        <ClaimDetail />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/claims/new',
    element: (
      <PrivateRoute>
        <ClaimNew />
      </PrivateRoute>
    )
  },
  {
    path: '/:issuer/dashboard',
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    )
  },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
